<template>
  <div class="team">
    <!-- 分类 -->
    <!-- <van-nav-bar title="全部分类" fixed /> -->

    <!-- 搜索框 -->
     <div v-if="isAdmin">
    <van-search fixed
      v-model="userId"
      show-action
      placeholder="请输入用户编码搜索"
      clearable
    >
      <template #action>
        <div @click="goSearch()">搜索</div>
      </template>
    </van-search>
    <div style="width: 100%;height: 60px;"></div>
    </div>

    <!-- 分类列表 -->
    <div class="list-box" style="overflow: auto; height: 84%;">
      <!-- 下拉刷新组件 -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 列表组件 -->
      <van-list v-model="loading" :finished="finished" :finished-text="bomTitle"   @load="onLoad" :offset="20"  :immediate-check="false" > 
        <!-- 列表项 -->
        <div v-if="list.length == 0" class="team_empty"><van-empty description="暂无团队成员" /></div>
        <div v-for="(item, index) in list" :key="index" class="listBox">
          <van-swipe-cell>
            <van-row  class="team_content">
                  <van-col  span="3" offset="1"  class="level_f">
                      <van-image v-if="item.avatarUrl" round width="3rem" height="3rem" :src="item.avatarUrl" />
                      <van-image v-else  round width="3rem" height="3rem" :src="require('@/assets/img/user.png')" />
                      <img  v-if="item.level == 0" :src="require('@/assets/img/level_0.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 1" :src="require('@/assets/img/level_1.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 2" :src="require('@/assets/img/level_2.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 3" :src="require('@/assets/img/level_3.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 4" :src="require('@/assets/img/level_4.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 5" :src="require('@/assets/img/level_5.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 6" :src="require('@/assets/img/level_6.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 7" :src="require('@/assets/img/level_7.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 8" :src="require('@/assets/img/level_8.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 9" :src="require('@/assets/img/level_9.png')"  alt="" class="level_s"/>
                      <img  v-if="item.level == 10" :src="require('@/assets/img/level_10.png')"  alt="" class="level_s"/>
                  </van-col>
                  <van-col span="19" offset="1">
                    <div>
                      <p>{{ item.niceName }}<span class="team_grade">团队<i>{{ item.teamLevel }}</i>级</span></p>
                      <p class="user_commission">用户编码: {{ item.id }}</p>
                    </div>
                  </van-col>
                  <img  v-if="item.status == 0" :src="require('@/assets/img/not_active.png')"  alt="" class="not_active"/>
            </van-row>

            <template #right v-if="isAdmin">
                    <van-button square type="primary" text="激活"  v-if="item.status == 0" @click="activeUser(item)"/>
                    <van-button square type="warning" text="重置"   v-if="item.withOutPassword" @click="resetWithdrawPassword(item)" />
                    <van-button square type="danger" text="禁用"   v-if="item.status == 1"  @click="disableUser(item)" />
                    <van-button square type="danger" text="恢复"   v-if="item.status == 2"  @click="enableUser(item)" />
                    <van-button square type="info" text="详情"   v-if="item.status != 0"  @click="detailUser(item)" />
            </template>
          </van-swipe-cell>
              <div v-if=" item.child && item.child.length > 0"> 
                   <div v-for="(item1, index1) in item.child" :key="index1">
                    <van-swipe-cell>
                      <van-row  class="team_content">
                      <van-col  span="3" offset="3" class="level_f">
                        <van-image v-if="item1.avatarUrl" round width="3rem" height="3rem" :src="item1.avatarUrl" />
                        <van-image v-else  round width="3rem" height="3rem" :src="require('@/assets/img/user.png')" />
                        <img  v-if="item1.level == 0" :src="require('@/assets/img/level_0.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 1" :src="require('@/assets/img/level_1.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 2" :src="require('@/assets/img/level_2.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 3" :src="require('@/assets/img/level_3.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 4" :src="require('@/assets/img/level_4.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 5" :src="require('@/assets/img/level_5.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 6" :src="require('@/assets/img/level_6.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 7" :src="require('@/assets/img/level_7.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 8" :src="require('@/assets/img/level_8.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 9" :src="require('@/assets/img/level_9.png')"  alt="" class="level_s"/>
                      <img  v-if="item1.level == 10" :src="require('@/assets/img/level_10.png')"  alt="" class="level_s"/>
                      </van-col>
                      <van-col span="17"  offset="1">
                      <div >
                        <p>{{ item.niceName }}<span class="team_grade">团队<i>{{ item1.teamLevel }}</i>级</span></p>
                      <p class="user_commission">用户编码: {{ item1.id }}</p>
                      </div>
                  </van-col>
                     <img  v-if="item1.status == 0" :src="require('@/assets/img/not_active.png')"  alt="" class="not_active"/>
                </van-row>
                  <template #right v-if="isAdmin">
                    <van-button square type="primary" text="激活"  v-if="item1.status == 0" @click="activeUser(item1)"/>
                    <van-button square type="warning" text="重置"   v-if="item1.withOutPassword" @click="resetWithdrawPassword(item1)" />
                    <van-button square type="danger" text="禁用"   v-if="item1.status == 1"  @click="disableUser(item1)" />
                     <van-button square type="danger" text="恢复"   v-if="item1.status == 2"  @click="enableUser(item1)" />
                    <van-button square type="info" text="详情"   v-if="item.status != 0"  @click="detailUser(item1)" />
                  </template>
          </van-swipe-cell>
             </div>
          </div> 
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
  <BackButton @back="share" ><div class="recharge_but">点我分享</div></BackButton>
 

   <van-popup v-model="accountShow" round  :style="{ height: '27%',width:'85%' }" class="user_account_popup" >
    <div class="center">
      <div class="tikTok_text">
        <span class="tikTok_desc">抖音号: </span>
        <span class="text" v-if="accountInfo.tikTokNum">{{ accountInfo.tikTokNum }}</span>
        <span class="text" v-else>未绑定</span>
      </div>
      <div class="center_down">
        <div class="center_rank">
         <div class="money_desc">{{ moneyFmt(accountInfo.myGrade) }}</div>
        <div class="rank_text">达人算力</div>
        </div>
        <div class="center_rank">
          <div class="money_desc">{{ moneyFmt(accountInfo.teamGrade) }}</div>
          <div class="rank_text">团队算力</div>
        </div>
      </div>
      <div class="center_down" style="position: relative;">
        <div class="center_rank">
         <div class="money_desc">￥{{ moneyFmt(accountInfo.incomeAmount) }}</div>
        <div class="rank_text">累计佣金</div>
        </div>
        <div class="center_rank">
          <div class="money_desc">＋￥{{ moneyFmt(accountInfo.income) }} </div>
          <div class="rank_text">昨日佣金</div>
        </div>
        
      </div>
    </div>
   </van-popup>
  </div>
</template>

<script>
import { isAdmin } from "@/utils/common.js";
import { moneyFmt } from "@/utils/moneyUtil";
import { getMyTeam,resetWithdrawPassword,activeUser,disableUser,enableUser } from "@/api/team";
import {getOfficialSupperAccountInfo } from "@/api/user";

export default {
  name: "CategoryPage",
 data() {
    return {
      isAdmin: false,
      userId: null,
      dataSet: {
        limit: 10,
        pageNum: 1,
      },
      list: [], // 列表数据
      isLoading: false, // 控制下拉刷新的加载状态
      loading: false, // 控制上拉加载的加载状态
      finished: true, // 是否已加载完全部数据
      bomTitle: '', // 上拉加载完成时的文本
      pageTotal: 0,
      accountShow:false,
      accountInfo: {}
      
    }
  },
  created() {
    this.isAdmin = isAdmin();
    
  },
   mounted() {
    this.informPort(); //列表数据接口
    },
    methods: {
    // 获取列表数据
    informPort(flag) {
      getMyTeam(this.dataSet.pageNum,this.userId).then(res => {
        console.log(res)
        if (res.code == 200 && res.rows) {
          console.log(res)
          let dataList = res.rows
          if (dataList && dataList.length) {
            if (flag) {
              this.list = dataList
            } else {
              this.list = [...this.list, ...dataList]
            }
          }
          this.pageTotal = res.total
          if (this.list.length >= this.pageTotal) {
            this.bomTitle = '到底了~ ' + '共计' + res.total + '条'
            this.finished = true
          } else {
            this.loading = false
            this.finished = false
            this.dataSet.pageNum += 1
            this.bomTitle = ''
          }
        }
      })
    },
    
    share(){
      this.$router.push('/share');
    },
    // 搜索
    goSearch() {
      this.dataSet.pageNum = 1
      this.finished = false
      this.list = []
      this.informPort(true)
    },
    // 下拉刷新
    onRefresh() {
      this.dataSet.pageNum = 1
      this.finished = true
      this.loading = true
      this.list = []
      this.isLoading =true
      setTimeout(() => {
        this.isLoading = false // 结束下拉刷新的加载状态
        this.informPort(true) // 重新获取列表数据
        this.$toast.success('刷新成功')
      }, 300)
    },
    // 上拉加载
    onLoad() {
      this.informPort() 
      // 获取更多列表数据
      
    },
    activeUser(item) {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "你确认要激活 "+ item.niceName +" 用户吗？",
          className: 'dialog_class'
        })
        .then(() => {
          activeUser(item.id).then(resp=>{
            if(resp.code == 200){
              item.status = 1
              this.$toast.success('激活成功')
            }else {
              this.$toast.success(resp.msg)
            }
          })
        })
        .catch(() => {});
    },
    resetWithdrawPassword(item) {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "你确认要重置 "+ item.niceName +" 的提现密码用户吗？",
          className: 'dialog_class'
        })
        .then(() => {
          resetWithdrawPassword(item.id).then(resp=>{
            if(resp.code == 200){
              this.$toast.success('重置成功')
              item.withOutPassword =''
            }else {
              this.$toast.fail(resp.msg)
            }
          })
        })
        .catch(() => {});
    },
    disableUser(item) {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "你确认要禁用 "+ item.niceName +" 用户吗？",
          className: 'dialog_class'
        })
        .then(() => {
          disableUser(item.id).then(resp=>{
            if(resp.code == 200){
              this.$toast.success('禁用成功')
              item.status = 2
            }else {
              this.$toast.fail(resp.msg)
            }
          })
        })
        .catch(() => {});
    },

    enableUser(item) {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "你确认要恢复 "+ item.niceName +" 用户吗？",
          className: 'dialog_class'
        })
        .then(() => {
          enableUser(item.id).then(resp=>{
            if(resp.code == 200){
              this.$toast.success('恢复成功')
              item.status = 1
            }else {
              this.$toast.fail(resp.msg)
            }
          })
        })
        .catch(() => {});
    },
    detailUser(item){
      this.accountInfo = {};
      getOfficialSupperAccountInfo(item.id).then(res =>{
        if(res.code == 200){
           this.accountInfo = res.data
           this.accountInfo.tikTokNum = item.tikTokNum;
           this.accountShow =true;
            }else {
              this.$toast.fail(res.msg)
            }
      })
     
    },
    moneyFmt(num){
       return moneyFmt(num)
    },
  }
};
</script>

<style lang="less" scoped>

.team {
  width: 100%;
  height: 100vh;
  background: url(@/assets/img/team_bg.png) no-repeat left center;
  background-size: 100% 100%;
  overflow: hidden;
}
.team_empty {
  margin-top: 20%;
  font-weight: 700;
}
.team_content {
  display: flex;
  align-items: center;
  color: #f0f1f3;
  margin-top: 0.5%; 
  font-size: 18px;
  position: relative;
}
.team_content .user_commission{
  color: #979797;
  margin-top: 0.5%; 
  font-size: 16px;
}
.level_f {
  position: relative;
}
.level_s {
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  left: 53%;
  bottom: 5%;
}


// 主题 padding
.category {
  padding-top: 100px;
  padding-bottom: 50px;
  height: 100vh;
  .list-box {
    height: 100%;
    display: flex;
    .left {
      width: 85px;
      height: 100%;
      background-color: #f3f3f3;
      overflow: auto;
      a {
        display: block;
        height: 45px;
        line-height: 45px;
        text-align: center;
        color: #444444;
        font-size: 12px;
        &.active {
          color: #fb442f;
          background-color: #fff;
        }
      }
    }
    .right {
      flex: 1;
      height: 100%;
      background-color: #ffffff;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      padding: 10px 0;
      overflow: auto;

      .cate-goods {
        width: 33.3%;
        margin-bottom: 10px;
        img {
          width: 70px;
          height: 70px;
          display: block;
          margin: 5px auto;
        }
        p {
          text-align: center;
          font-size: 12px;
        }
      }
    }
  }
}

// 导航条样式定制
.van-nav-bar {
  z-index: 999;
}

// 搜索框样式定制
.van-search {
  position: fixed;
  width: 100%;
  top: 46px;
  z-index: 999;
}
.recharge_but {
    color: #fff;
    font-weight: 700;
    background: url(@/assets/img/float_btn.png) no-repeat left center;
    background-size: 100% 100%;
    padding: 5px;
    border-radius: 10px;
}
::v-deep .van-search__action {
    background-color: #0a58bf;
    color: #fff;
    padding: 0 20px;
    border-radius: 0 5px 5px 0;
    margin-right: 10px;
  }
  ::v-deep .van-icon-arrow-left {
    color: #333;
  }
  ::v-deep .van-search {
    top: 5px;
  }
  ::v-deep .van-dialog {
    background-color: #0a58bf !important;
  }
  .team_grade {
    font-size: 14px;
    background-color: #244969;
    padding: 2px 5px;
    color: #36b9b9; 
    display: inline-block;
    margin-left: 5px;
  }
  .team_grade i {
    font-size: 16px;
    font-weight: 700;
  }
  .not_active {
    position:absolute;
    width: 3.5rem;
    height: 3.5rem;
    left: 84%;
    z-index: 999;
  }

  .user_account_popup {
    background: url(@/assets/img/my_info_bg.png) no-repeat left center;
    background-size: 100% 100%;
    margin: 0 auto;
    border-radius: 8px;
    padding: 30px;
    padding-top: 20px;
  }
  .center_down {
    padding: 3.5% 0;
    display: flex;
    justify-content: space-around;
    .center_rank {
      text-align: center;
      .money_desc {
        font-size: 20px;
        color: #f0f1f3;
        font-weight: 700;
      }
  
      .rank_text {
        font-size: 13px;
        color: #979797;
        font-weight: 400;
        margin-top: 2px;
      }
    }
  }

   .tikTok_text {
      text-align: center;
      .text {
        font-size: 20px;
        color: #f0f1f3;
        font-weight: 700;
      }
  
      .tikTok_desc {
        font-size: 13px;
        color: #979797;
        font-weight: 400;
        margin-top: 2px;
      }
  }
</style>